/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_Return_LabelInputs */

const en_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 year return`)
};

const de_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1-Jahres-Rendite`)
};

const pt_br2_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retorno em 1 ano`)
};

const tr_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 yıllık getiri`)
};

const zh_cn2_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1年回报`)
};

const zh_hk2_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1年回報`)
};

const ko_kr2_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1년 수익률`)
};

const ru_ru2_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доходность за 1 год`)
};

const es_419_onboarding_v1_pick_return_label = /** @type {(inputs: Onboarding_V1_Pick_Return_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento a 1 año`)
};

/**
* | output |
* | --- |
* | "1 year return" |
*
* @param {Onboarding_V1_Pick_Return_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_return_label = /** @type {((inputs?: Onboarding_V1_Pick_Return_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_Return_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_return_label(inputs)
	if (locale === "de") return de_onboarding_v1_pick_return_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_return_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_return_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_return_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_return_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_return_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_return_label(inputs)
	return es_419_onboarding_v1_pick_return_label(inputs)
});